<script lang="ts" setup>
import { PARTIAL_VIEW, topLevelClass } from '@/constants'
import { inject } from 'vue'

/**
 * Check if the environment is dev.
 */
const isDev = process.env.NODE_ENV === 'development'

/**
 * Whether a partial view should be displayed.
 */
const isPartialView = inject(PARTIAL_VIEW)
</script>

<template>
    <div style="position: relative; height: 100%" :class="topLevelClass">
        <Suspense>
            <PartialView v-if="isPartialView" />
            <MainView v-else />
        </Suspense>

        <!-- This is just to add buttons in dev mode -->
        <TestingWrapper v-if="!isPartialView && isDev" />

        <!-- This is to ensure that HeadlessUI portal is rendered inside our app. -->
        <div
            id="headlessui-portal-root"
            class="pointer-events-auto absolute z-[1000]"
        >
            <span />
        </div>
    </div>
</template>

<style>
@tailwind base;
@tailwind components;
@tailwind utilities;
</style>